import React from 'react'
import styled from 'styled-components'
import Logo from './Logo'
import { Chip, Nav, NavItem, SkeletonBox, Text, theme } from '@containous/faency'
import { useHistory } from 'react-router-dom'
import Badge from './Badge'
import { useCurrentGroup } from '../hooks/use-current-group'

const CustomNav = styled(Nav)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;

  div {
    flex-direction: row;
    flex-wrap: nowrap;
  }
`

export const Header = () => {
  const history = useHistory()
  const [group, { isLoading }] = useCurrentGroup()

  return (
    <CustomNav>
      <NavItem onClick={(): void => history.replace('/')}>
        <Logo as="button" />
      </NavItem>
      <NavItem disabled>
        <Text sx={{ color: theme.colors.grays[4], fontWeight: 'bold', fontSize: 3 }}>API Portal</Text>
        {isLoading && <SkeletonBox sx={{ height: '20px', width: '60px', borderRadius: '20px', ml: '5px' }} />}
        {!!group && group !== 'all' && (
          <Chip variant="blue" sx={{ ml: '8px' }}>
            {group}
          </Chip>
        )}
      </NavItem>
    </CustomNav>
  )
}
